import { useContext } from 'react'

import { WinninAIReportContext } from './context'

export const useWinninAIReport = () => useContext(WinninAIReportContext)
